import angular from "angular";
import { Tooltip } from "bootstrap";

/**
 * Fires the necessary Bootstrap 5 initialization for the given element.
 * @example
 * ```html
 * <a href="#" sxy-bs5-tooltip data-bs-toggle="tooltip" data-bs-title="Default tooltip">inline links</a>
 * ```
 */
export class Bs5Tooltip implements angular.IDirective {

  /**
   * Factory for directive registration.
   * @ignore
   */
  public static salaxyBs5Tooltip() {
    const factory = () => new Bs5Tooltip();
    factory.$inject = [];
    return factory;
  }

  /**
   * Applies to attributes only.
   * @ignore
   */
  public restrict = "A";

  /**
   * Creates a new instance of the directive.
   */
  constructor() {}

  /**
   * Attaches the appropriate Bootstrap scripts to the element.
   * @ignore
   */
  public link(scope: any, element: JQLite, attrs: any) {
    new Tooltip(element[0], {
      title: "<div>" + attrs.title + "</div>",
      html: true
    });
  }
}